/* flow */

import React, { Component } from 'react';

import styles from '../scss/components/footer.scss';

/*
 * This is the Footer component that has links to
 * Kinja-y stuff
 */
export default class Footer extends Component {
	onClick(label) {
		this.props.ga.event('Interactives: The Root 100 - 2019', 'Footer: Link click', {eventLabel: label});
	}

	renderFooterLinks() {
		const footerLinks = [
			{	label: 'About',
				url: 'http://www.theroot.com/about'
			}, {
				label: 'Need Help',
				url: 'https://kinja.desk.com/'
			}, {
				label: 'Content Guide',
				url: 'http://legal.kinja.com/content-guidelines-90185358'
			}, {
				label: 'Privacy',
				url: 'http://legal.kinja.com/privacy-policy-1793094625'
			}, {
				label: 'Terms of Use',
				url: 'http://legal.kinja.com/kinja-terms-of-use-1793094100'
			}, {
				label: 'Advertising',
				url: 'http://thefmg.com/'
			}, {
				label: 'Jobs',
				url: 'http://gizmodo.com/careers'
			}
		];

		return footerLinks.map((footerLink, i) => (
			<li key={i}>
				<a href={footerLink.url} target='_blank' onClick={() => this.onClick(footerLink.label)}>
					{footerLink.label}
				</a>
			</li>
		));
	}

	render() {
		return (
			<div className={styles.footerWrap}>
				<ul className={styles.footerList}>
					{this.renderFooterLinks()}
				</ul>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/components/footer.js